import React from 'react';
import styles from '../CartItemsTable.scss';
import Rater from 'react-rater';
import {formatCartItemTextSM} from 'src/logic/utils';
import cx from 'classnames';
import {getScreenWidth} from 'src/logic/utils';

export default function TableSupplier({logo, rating}) {

  const isMobileScreenHeight = (parseInt(getScreenWidth()) <= 1024);
  const supplierNameClassName = {
    [styles.supplierName]: true,
    [styles.supplierNameRtl]: isMobileScreenHeight
  };

  return (
    <div className={styles.supplierNameBlock}>
        <span className={cx(supplierNameClassName)}>{formatCartItemTextSM(logo)}</span>
        <Rater className={`${styles.rater} react-rater`} interactive={false} rating={+rating} />
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/CartPage/elements/tableElements/TableSupplier.jsx
 **/